import { Result } from 'antd';
import { ResultProps } from 'antd/lib/result';

interface Props extends ResultProps {}

export default function EnhancedResult({ ...rest }: Props) {
  return <Result {...rest} />;
}
